var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVira(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 13,
    fill: "#4F66AA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.97005 7.73503C7.97005 8.55518 7.30518 9.22005 6.48503 9.22005C5.66487 9.22005 5 8.55518 5 7.73503C5 6.91487 5.66487 6.25 6.48503 6.25C7.30518 6.25 7.97005 6.91487 7.97005 7.73503Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3639 14.9247L14.6694 10.8611C15.5433 8.7432 19.2502 9.47444 18.8059 10.2439L13.7809 18.9475L13.7512 18.997C13.4435 19.4889 12.9092 19.7598 12.3632 19.752C11.8173 19.7598 11.2829 19.4889 10.9753 18.997L10.9456 18.9475L7.15629 12.2615C6.71204 11.492 6.97567 10.5081 7.74514 10.0639C8.49788 9.62926 9.45584 9.87212 9.91304 10.6032L9.94277 10.6527L12.3639 14.9247Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8006 14.6938C17.9634 14.9739 18.08 15.1745 18.08 15.1745L18.0922 15.1935C18.2873 15.4707 19.2129 16.0493 20.2129 15.5189C21.213 14.9886 21.0405 13.8671 20.8665 13.5657L19.6577 11.4772L17.8006 14.6938Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVira);
export default __webpack_public_path__ + "static/media/vira.76ff39e8e16811d0afa6c0bfb707e637.svg";
export { ForwardRef as ReactComponent };